export default __webpack_public_path__ + "images/20_1_image.jpg";